import React from 'react';
import { useWeather } from '../../context/WeatherContext';
import { Select } from '../ui/Select';
import { modelOptions } from '../../constants/parameters';

export function ModelSelector() {
  const { modelSelect, setModelSelect, setParameterSelect, setStartDate, setEndDate, mapInstance, drawInstance } = useWeather();

  const handleModelChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;
    setModelSelect(newValue);

    // Set default parameter based on model
    if (newValue === 'wildfire') {
      // Clear parameter for wildfire model
      setParameterSelect('');
      
      // Set date range to last 5 days until now
      const now = new Date();
      const fiveDaysAgo = new Date();
      fiveDaysAgo.setDate(now.getDate() - 5);
      
      setEndDate(now.toISOString().split('T')[0]);
      setStartDate(fiveDaysAgo.toISOString().split('T')[0]);

      // Set broader LA polygon covering Palisades, Eaton, Hurst
      if (mapInstance && drawInstance) {
        drawInstance.deleteAll();
        drawInstance.add({
          type: 'Feature',
          geometry: {
            type: 'Polygon',
            coordinates: [[
              [-118.9, 33.7],  // Southwest - expanded west
              [-118.9, 34.5],  // Northwest - expanded north
              [-117.5, 34.5],  // Northeast - expanded east
              [-117.5, 33.7],  // Southeast
              [-118.9, 33.7]   // Back to start
            ]]
          }
        });

        mapInstance.flyTo({
          center: [-118.2, 34.1], // Centered more north to include all areas
          zoom: 8.5, // Zoomed out slightly to show broader area
          duration: 2000
        });
      }
    }
  };

  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-[var(--secondary-text)] mb-2">
        Weather Model
      </label>
      <Select
        value={modelSelect}
        onChange={handleModelChange}
        options={modelOptions}
      />
    </div>
  );
}